/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompagnieMinimalDto } from './CompagnieMinimalDto';
import {
    CompagnieMinimalDtoFromJSON,
    CompagnieMinimalDtoFromJSONTyped,
    CompagnieMinimalDtoToJSON,
    CompagnieMinimalDtoToJSONTyped,
} from './CompagnieMinimalDto';

/**
 * Annuaire des compagnies porteurs de risque.
 * @export
 * @interface GetCompagniesResponse
 */
export interface GetCompagniesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCompagniesResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CompagnieMinimalDto>}
     * @memberof GetCompagniesResponse
     */
    items?: Array<CompagnieMinimalDto>;
}

/**
 * Check if a given object implements the GetCompagniesResponse interface.
 */
export function instanceOfGetCompagniesResponse(value: object): value is GetCompagniesResponse {
    return true;
}

export function GetCompagniesResponseFromJSON(json: any): GetCompagniesResponse {
    return GetCompagniesResponseFromJSONTyped(json, false);
}

export function GetCompagniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompagniesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CompagnieMinimalDtoFromJSON)),
    };
}

export function GetCompagniesResponseToJSON(json: any): GetCompagniesResponse {
    return GetCompagniesResponseToJSONTyped(json, false);
}

export function GetCompagniesResponseToJSONTyped(value?: GetCompagniesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CompagnieMinimalDtoToJSON)),
    };
}

